import { getContractRetainerSpendByContractId } from "@features/projects-feature/hooks/useGetContractRetainersByContractId";
import type { UsageBalanceData, UsageBalanceHookOptions } from "shared-ui/src/features/contracts-feature/canonical";

export function useRetainerUsageBalance(
  contractId?: number,
  _options?: UsageBalanceHookOptions,
): UsageBalanceData {
  const { data, isLoading, error } =
    getContractRetainerSpendByContractId(contractId);

  let usage = { Consumed: 0, Pending: 0, "Total Usage": 0 };
  let balance = {
    "Retainer Amount": 0,
    "Current Balance": 0,
    "Remaining Balance": 0,
    "Total Invoiced": 0,
  };

  if (data) {
    const {
      billedSpend = 0,
      pendingSpend = 0,
      billedOverage = 0,
      totalActiveRetainerAmount = 0,
    } = data;

    usage = {
      Consumed: billedSpend,
      Pending: pendingSpend,
      "Total Usage": billedSpend + pendingSpend,
    };
    balance = {
      "Retainer Amount": totalActiveRetainerAmount,
      "Current Balance": totalActiveRetainerAmount - billedSpend,
      "Remaining Balance":
        totalActiveRetainerAmount - (billedSpend + pendingSpend),
      "Total Invoiced": totalActiveRetainerAmount + billedOverage,
    };
  }

  return {
    usage,
    balance,
    balanceLabel: "Retainer",
    isLoading,
    error,
  };
}
